import Vue from "vue";
import App from "./App";
import router from "./router/index";
import axios from 'axios'
import store from './store'
import VueLayers from 'vuelayers'
import 'vuelayers/lib/style.css'
import './plugins/bootstrap-vue'
import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";
import './plugins/vuesax.js'
import VeeValidate from 'vee-validate';
Vue.prototype.$http = axios.create({
  baseURL: "http://inggepro.sytes.net:4000/api/"
});
Vue.use(VeeValidate);
Vue.use(PaperDashboard);
Vue.use(VueLayers);
/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
